var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer',[_c('p',[_vm._v("copyright © 2018 磐石保險經紀人股份有限公司")])])}
var staticRenderFns = []

export { render, staticRenderFns }